import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Layout from './publicLayout';
import { useAuth } from '../contexts/authContext';

const PublicRoute = (props) => {
  const { authenticated, currentUserProfile } = useAuth();
  const location = useLocation();

  const isInviteRoute = location.pathname.startsWith('/invite/');

  if (authenticated && !isInviteRoute && (currentUserProfile.email || currentUserProfile.phone)) {
    return <Navigate to={'/overview'} />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PublicRoute;
